import { t } from "./i18n";

// A gate is a single per-customer yes/no question asked up front. The affirmative answer
// continues the funnel; the negative answer routes to the compassionate off-ramp. Keeping this
// config-driven (not hard-coded to Florida) preserves the reusable-engine boundary: adding a
// hospice means new config, not new funnel code.
export interface GateConfig {
  /** i18n key for the gate heading. */
  titleKey: string;
  /** i18n key for the yes/no question. */
  questionKey: string;
  /** i18n key for supporting help text. */
  helpKey: string;
}

export interface GateCallbacks {
  onPass: () => void;
  onFail: () => void;
}

export const FLORIDA_GATE: GateConfig = {
  titleKey: "ui.gate.title",
  questionKey: "ui.gate.florida.question",
  helpKey: "ui.gate.florida.help",
};

export function renderGate(
  container: HTMLElement,
  config: GateConfig,
  callbacks: GateCallbacks
): void {
  while (container.firstChild) container.removeChild(container.firstChild);

  const wrapper = document.createElement("div");
  wrapper.className = "gate";

  const heading = document.createElement("h2");
  heading.textContent = t(config.titleKey);
  wrapper.appendChild(heading);

  const question = document.createElement("p");
  question.className = "gate-question";
  question.textContent = t(config.questionKey);
  wrapper.appendChild(question);

  const help = document.createElement("p");
  help.className = "help-text";
  help.textContent = t(config.helpKey);
  wrapper.appendChild(help);

  const actions = document.createElement("div");
  actions.className = "gate-actions";

  const yesBtn = document.createElement("button");
  yesBtn.type = "button";
  yesBtn.className = "btn-primary";
  yesBtn.dataset.gate = "yes";
  yesBtn.textContent = t("ui.gate.yes");
  yesBtn.addEventListener("click", () => callbacks.onPass());
  actions.appendChild(yesBtn);

  const noBtn = document.createElement("button");
  noBtn.type = "button";
  noBtn.className = "btn-secondary";
  noBtn.dataset.gate = "no";
  noBtn.textContent = t("ui.gate.no");
  noBtn.addEventListener("click", () => callbacks.onFail());
  actions.appendChild(noBtn);

  wrapper.appendChild(actions);
  container.appendChild(wrapper);
}
